function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { eventsList } from '../../events/list';
import { initPolling } from '../../services/polling';
import { initResumable } from '../../services/resumable';
import { CorrelationId } from '../../utils/CorrelationId';
import { initHttp } from '../../utils/http';
import { extendDeep, get } from '../../utils/utils';
import { addEvents } from '../decorators';
import { initFolder } from './folder';
import { initFolders } from './folders';
import { initFoldersTrash } from './folders.trash';
import { initItem } from './item';
import { initItems } from './items';
import { initItemsTrash } from './items.trash';
import { toFolder } from './mappers/folder';
import { toItem } from './mappers/item';
import { initRefreshTokenWrapper } from './refresh-token-wrapper';
import { defaultSettings } from './settings';
import { initSocket } from './socket';
import { initTrash } from './trash';
import { initUser } from './user';
export function PrivateSite(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }

  if (!userSettings.siteMediaToken) {
    throw new Error('siteMediaToken param is missing');
  }

  this.siteMediaToken = userSettings.siteMediaToken;
  var settings = extendDeep({
    requestOptions: {
      params: {
        site_token: userSettings.siteMediaToken
      }
    }
  }, defaultSettings, userSettings);
  var withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
  var requestOptions = settings.requestOptions;

  if (get(requestOptions, 'params.ns')) {
    settings.ns = requestOptions.params.ns;
  }

  var socket = initSocket(settings, this, requestOptions);
  var correlationId = new CorrelationId();
  var http = initHttp(requestOptions);
  var polling = initPolling(settings, this, toItem, http, {
    path: '/site/media/files'
  });
  var resumable = initResumable(settings, this, toItem, http);
  var settingsWithRefreshToken = {
    get: withRefreshToken(http.get),
    post: withRefreshToken(http.post),
    upload: withRefreshToken(http.upload)
  };
  var httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;

  var trashSettings = _objectSpread({}, settings, {
    sourceName: 'trash'
  });

  var folders = initFolders(settings, httpWithRefreshToken);
  var foldersTrash = initFoldersTrash(trashSettings, httpWithRefreshToken);
  var folder = initFolder(settings, httpWithRefreshToken);
  var items = initItems(settings, httpWithRefreshToken);
  var itemsTrash = initItemsTrash(trashSettings, httpWithRefreshToken);
  var item = initItem(settings, httpWithRefreshToken, socket, polling, resumable);
  var trash = initTrash(trashSettings, httpWithRefreshToken);
  var user = initUser(settings, httpWithRefreshToken);
  folders.trash = foldersTrash;
  items.trash = itemsTrash;
  this.name = settings.name || 'private-site';
  this.correlationId = correlationId;
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.folder = addEvents(this, eventsList.FOLDER, folder);
  this.item = addEvents(this, eventsList.ITEM, item);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.trash = addEvents(this, eventsList.TRASH, trash);
  this.user = addEvents(this, eventsList.USER, user);

  this.toItem = function (data) {
    return toItem(data, settings, settings.thumbnailSizes);
  };

  this.toFolder = function (data) {
    return toFolder(data, settings);
  };

  this.blackArrow = socket;
}